import { AfterViewInit,Directive,ElementRef,OnDestroy } from '@angular/core';

@Directive({
  selector: '[appRestartDialog]'
})
export class RestartDialogDirective implements AfterViewInit,OnDestroy {
  private static readonly FOCUS_MODAL_AFTER_MILLISECONDS = 250;
  private previousFocusedElement: Element;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.previousFocusedElement = document.activeElement;
    let elements = (this.el.nativeElement as HTMLElement).querySelectorAll('.modal-input');
    if (elements.length > 0) {
      this.focusFirstElement(elements);
    } else {
      elements = (this.el.nativeElement as HTMLElement).querySelectorAll('.modal-close-button');
      if (elements.length > 0) {
        this.focusFirstElement(elements);
      } else {
        elements = (this.el.nativeElement as HTMLElement).querySelectorAll('.modal-ok-button');
        if (elements.length > 0) {
          this.focusFirstElement(elements);
        }
      }
    }
  }

  focusFirstElement(elements: NodeListOf<Element>) {
    setTimeout(() => {
      (elements[0] as HTMLElement).focus();
    }, RestartDialogDirective.FOCUS_MODAL_AFTER_MILLISECONDS);
  }

  ngOnDestroy(): void {
    // (this.previousFocusedElement as HTMLElement)?.focus();
  }

}
